module.exports = __webpack_public_path__ + "static/media/Icon_Standby_White.5203af2c.png";